import service from "./service";

export const findAll = listQuery => {
  return service.get("/v1/contactCustomer", listQuery);
};

export const findOne = id => {
  return service.get(`/v1/contactCustomer/${id}`);
};

export const findQuota = id => {
  return service.get(`/v1/quota/contactCustomer/${id}`);
};

export const update = (id, data) => {
  return service.post(`/v1/contactCustomer/${id}`, data);
};

export const setDefault = (id, data) => {
  return service.post(`/v1/contactCustomer/${id}/default`, data);
};

export const create = data => {
  return service.post(`/v1/contactCustomer`, data);
};
